import {
  Message,
  MessageSender,
  MessageStatus,
  MessageType,
  RiskStatus,
  UploadFileInfo,
} from "@/app/store/types";
import React from "react";
import SvgErrorMsg from "@/app/icons/SvgErrorMsg.svg";
import Locale from "@/app/locales";
import { webSocketService } from "@/app/services/WebSocketService";
import { ensureWebSocketReadyForResend } from "@/app/services/ensureSocketForResend";
import { Spin, Toast } from "@douyinfe/semi-ui";
import { useFileUpload } from "@/app/hooks/useFileUpload";
import { fileUploadApi } from "@/app/api/file";
import { isForbiddenMsg } from "@/app/store/formatMessage";

interface IProps {
  msg: Message;
}
export default function MsgStatus(props: IProps) {
  const { senderType, status, fileInfo } = props.msg;
  const { onSuccess, beforeUpload, onError } = useFileUpload();

  const handleResend = async () => {
    if (props.msg.riskStatus === RiskStatus.Failed) {
      return;
    }
    if (!webSocketService.isConnected()) {
      const socketReady = await ensureWebSocketReadyForResend();
      if (!socketReady) {
        Toast.error(Locale.common.sendError);
        return;
      }
    }

    if (
      [
        MessageType.File,
        MessageType.Image,
        MessageType.Video,
        MessageType.Audio,
      ].includes(props.msg.type as MessageType) &&
      fileInfo
    ) {
      // Toast.warning("请重新上传");
      const { file, fileId } = fileInfo;
      await beforeUpload(file, fileId, true);

      // 上传到桶
      fileUploadApi({
        fileId,
        file,
        onError: (uid: string, fileInfo: UploadFileInfo) => {
          onError(uid, fileInfo);
        },
        onSuccess,
      });
      return;
    }
    webSocketService.retrySendMessage(props.msg, (isErr = false) => {
      if (isErr) {
        Toast.error(Locale.common.sendError);
      }
    });
  };

  if (isForbiddenMsg(props.msg)) {
    return (
      <SvgErrorMsg
        style={{
          cursor: "not-allowed",
          width: "24px",
        }}
        onClick={handleResend}
      />
    );
  }

  if (senderType !== MessageSender.USER || status === MessageStatus.Success) {
    return null;
  }
  switch (status) {
    case MessageStatus.Sending:
    case MessageStatus.Pending:
      return <Spin size="small" />;
    case MessageStatus.CLOSE:
    case MessageStatus.ERROR:
    case MessageStatus.Failed:
      return (
        <SvgErrorMsg
          style={{
            cursor: "pointer",
            width: "24px",
          }}
          onClick={handleResend}
        />
      );
    default:
      return null;
  }
}
